import React from 'react';
import { useLang } from '../contexts/LanguageContext';
import Marquee from 'react-fast-marquee';

export default function MarqueeSection() {
  const { t } = useLang();
  const text = t('marquee');

  return (
    <section data-testid="marquee-section" className="py-4 overflow-hidden bg-[#050505] relative">
      {/* Top line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-neon/40 to-transparent" />
      
      {/* Forward marquee - bright and visible */}
      <Marquee speed={50} gradient={false} className="overflow-hidden">
        <span className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-neon/20 select-none whitespace-nowrap mx-6">
          {text}
        </span>
        <span className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-neon/20 select-none whitespace-nowrap mx-6">
          {text}
        </span>
      </Marquee>
      
      {/* Reverse marquee with different color */}
      <div className="mt-1">
        <Marquee speed={35} gradient={false} direction="right" className="overflow-hidden">
          <span className="font-heading text-2xl sm:text-3xl font-black tracking-tighter text-pink/10 select-none whitespace-nowrap mx-6 uppercase">
            E-Mail Kalender Cloud ActiveSync Zimbra Office Anti-Spam DSGVO S/MIME 2FA CardDAV CalDAV Webmail
          </span>
          <span className="font-heading text-2xl sm:text-3xl font-black tracking-tighter text-pink/10 select-none whitespace-nowrap mx-6 uppercase">
            E-Mail Kalender Cloud ActiveSync Zimbra Office Anti-Spam DSGVO S/MIME 2FA CardDAV CalDAV Webmail
          </span>
        </Marquee>
      </div>
      
      {/* Bottom line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-pink/40 to-transparent" />
    </section>
  );
}
